import { Box, Typography } from '@mui/material';
import { AdvancedTourStep } from '../shared-types';
import { ComponentTourProps } from './component-tour-props';
import ButtonWrapper from '../../../components/custom-controls/button-wrapper/button-wrapper';
import { Dispatch, SetStateAction } from 'react';

export function getIntegrationTemplateHeaderTourSteps({
	defaultStyles,
	isEdit,
}: ComponentTourProps & { isEdit: boolean }): AdvancedTourStep[] {
	return [
		{
			id: 'paste-task',
			selector: '[data-tour="paste-task"]',
			content: 'After Copying a task it can be pasted to the flow diagram.',
		},
		{
			id: 'run-flow',
			selector: '[data-tour="run-flow"]',
			content: 'Run the flow and all tasks.',
		},
		{
			id: 'run-task',
			selector: '[data-tour="run-task"]',
			content: 'Run the currently selected task.',
		},
		{
			id: 'auto-task-layout',
			selector: '[data-tour="auto-task-layout"]',
			content: 'Re-arranges the tasks in the diagram to snap into set positions.',
		},
		{
			id: 'auto-task-layout-toggle',
			selector: '[data-tour="auto-task-layout-toggle"]',
			content:
				'Toggle whether the diagram is "Auto Layout" or move tasks around freely for control over how the diagram looks.',
		},
		{
			id: 'save-flow',
			selector: '[data-tour="save-flow"]',
			content:
				'Save the changes made to the flow, the button will only be enabled after changes have been made to the flow.',
		},
		{
			id: 'exit-edit-flow',
			selector: '[data-tour="exit-edit"]',
			content:
				'Exit the edit mode of the flow, if unsaved changes are present, the browser will alert and ask if you are sure you would like to leave the edit mode.',
		},
		{
			id: 'delete-flow',
			selector: '[data-tour="delete-flow"]',
			content: 'Delete the current version of the flow.',
		},
		{
			id: 'flow-versions',
			selector: '[data-tour="flow-versions"]',
			content:
				'A dropdown listing all the flow versions, making changes to a flow auto-increments the version number on saving.',
		},
		{
			id: 'flow-status',
			selector: '[data-tour="flow-status"]',
			content: ({ setIsOpen }: { setIsOpen: Dispatch<SetStateAction<boolean>> }) => (
				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
					<Typography>
						The current status of the flow, this allows the flow to be run, if it is disabled the
						flow will not be able to run.
					</Typography>
					<Typography>
						Congratulations on finishing the "Edit Flow Tutorial", click the button below to end the
						tutorial and continue adding additional tasks to your newly created flow.
					</Typography>
					<Box
						sx={{
							alignSelf: 'center',
						}}
					>
						<ButtonWrapper
							size="small"
							variant="light"
							id="exit-tutorial"
							label="Complete"
							onClick={() => {
								setIsOpen(false);
							}}
						/>
					</Box>
				</Box>
			),
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
